import {createEntityService} from "base/entity/service";
import {Service as DefaultService} from "app/common/service";
import {
    createEez,
    createEezList,
    eez_api_adapter,
    eez_list_api_adapter,
} from "app/eez/Eez";

const entityService = createEntityService(
    "/api/app/eez",
    createEez,
    createEezList,
    eez_api_adapter,
    eez_list_api_adapter
);

export const EezService = DefaultService(entityService);
